import { useState, useEffect } from "react";
import { Route, Routes } from "react-router-dom";

import Cards from "./routes/cards/Cards";
import Favorites from "./routes/favorites/Favorites";
import Home from "./routes/home/Home";
import { Calendarr } from "./routes/calendar/Calendarr";
import Recipe from "./routes/recipe/Recipe";
import Menu from "./routes/menu/Menu";
import AddCard from "./routes/addCard/AddCard";
import LoginOnboarding from "./routes/loginOnboarding/LoginOnboarding";
import Login from "./routes/login/Login";
import TutorialWhy from "./routes/tutorialWhy/tutorial-why";
import TutorialHow from "./routes/tutorialHow/tutorial-how";
import Subscription from "./routes/subscription/Subscription";
import Tag from "./routes/tags/Tag";
import Search from "./routes/search/Search";
import PolicyPrivacy from "./routes/tutorials/PolicyPrivacy";
import VerifyPayment from "./routes/verifyPayment/verifyPayment";
import Account from "./routes/menu/components/Account";
import { ProtectedRoutes, LoginRoute } from "./components/ProtectedRoutes";
import LoadingPage from "./components/LoadingPage";
import Chat from "./components/Papercups";
import Grocery from "./routes/grocery/Grocery";
import Ninja from "./routes/ninja/Ninja";
import Diets from "./routes/diet/Diets";

function App() {

  const [isLoading, setIsLoading] = useState(true);


  useEffect(() => {
    setIsLoading(true);
    // Simulate a delay to show the loading state
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  }, [window.location.pathname]); // Watch for changes in the URL


  return (
    <>

      <div className="container">
      
        <>
        {/* <Chat></Chat> */}
        <Routes>
          <Route element={<ProtectedRoutes />}>
            <Route path="/" element={<Home />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="/account" element={<Account />} />
            <Route path="/verify" element={<VerifyPayment />} />
            <Route path="/cards" element={<Cards />} />
            <Route path="/favorites" element={<Favorites />} />
            <Route path="/Search" element={<Search />} />
            <Route path="/tags/:id" element={<Tag />} />
            <Route path="/recipe/:id" element={<Recipe />} />
            <Route path="/grocery" element={<Grocery />} />
            <Route path="/calendar" element={<Calendarr />} />
            <Route path="/ninja" element={<Ninja />} />
            <Route path="/diet" element={<Diets />} />
            {/* <Route path="/addCard" element={<AddCard />} /> */}

          </Route>

          <Route element={<LoginRoute />}>
            <Route path="/login" element={<Login />} />
          </Route>

          <Route path="/loginOnboarding" element={<LoginOnboarding />} />
          <Route path="/policyPrivacy" element={<PolicyPrivacy />} />
          <Route path="/tutorialWhy" element={<TutorialWhy />} />
          <Route path="/tutorialHow" element={<TutorialHow />} />
          <Route path="/subscription" element={<Subscription />} />
          
          {/* <Route path="/fl" element={<FavList />} /> */}
          {/* <Route path="/card-menu" element={<CardMenu />} /> */}
          {/* <Route path="/contactus" element={<ContactUs />} /> */}

        </Routes>
        </>
        
      </div>
    </>
    );
}

export default App;
